module.exports = "/img/_/_/_/assets/images/avatar/full_left/female//warrior.jpg?e8a2b7bc357a9f94bdc5fff8d30d6ed7";